/**
 * Početna (APP1) curation rules (Q22, Q23). The values they use live in `@/config/home`.
 */
import { durationBucket } from './sessionBrowse';

interface Curatable {
  id: string;
  /** A `lukaaji_*` category from the catalogue. */
  category: string;
  duration: number;
  is_premium: boolean;
}

export interface FirstSessionRule {
  /** The session "Započni prvu sesiju" plays, while it is free (the button plays without an access check). */
  sessionId: string;
  /** If that session is missing: the first free session of this category, then any free session. */
  fallbackCategory: string;
}

/** The session the hero button plays, or null when the list has no free session. */
export function pickFirstSession<T extends Curatable>(sessions: readonly T[], rule: FirstSessionRule): T | null {
  const free = sessions.filter((session) => !session.is_premium);
  return (
    free.find((session) => session.id === rule.sessionId) ??
    free.find((session) => session.category === rule.fallbackCategory) ??
    free[0] ??
    null
  );
}

export interface ShortBreakRule {
  /** Most cards in the carousel; "Prikaži sve" opens the full list. */
  limit: number;
}

/** "Kratka pauza za sebe": sessions in A2's SOS bucket (≤ 5 displayed minutes), in list order. */
export function pickShortBreak<T extends Curatable>(sessions: readonly T[], rule: ShortBreakRule): T[] {
  return sessions.filter((session) => durationBucket(session.duration) === 'sos').slice(0, rule.limit);
}

/** Listening shorter than this is not worth a "Nastavi slušanje" card. */
export const RESUME_MIN_POSITION_SECONDS = 10;
/** A session this close to its end counts as finished. */
export const RESUME_END_MARGIN_SECONDS = 15;

/** Q23: a stored position is shown as "Nastavi slušanje" only while the session is unfinished. */
export function isUnfinished(position: number, duration: number): boolean {
  if (!Number.isFinite(position) || !Number.isFinite(duration) || duration <= 0) return false;
  return position >= RESUME_MIN_POSITION_SECONDS && duration - position > RESUME_END_MARGIN_SECONDS;
}
